export const environment = {
  production: false,
  apiUrl: "https://dev.api.happyhr.com/api/v2",

  hashKeys: {
    salt: "st@rtechupH@ppyHRH@ppyHR",
    keyLength: 12,
    secretKey: "h@ppyHRSt@rtechupabcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",
  },
};
